export class VehicleType {

    id:string;
    description:string;

    constructor(other ?:VehicleType) {
        if (other) {
            this.id = other.id;
            this.description = other.description;
        }
    }

    toString() {
        return this.description;
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/vehicleType.ts
 **/